/**
 * This is a placeholder, as i don't know how to make a webpack config without an entrypoint
 */
